import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27ed0bc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "new-kyc-form",
  style: {"position":"relative"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"position":"absolute","width":"100%","height":"100%"} }, null, -1))
const _hoisted_3 = { class: "d-flex flex-flow justify-content-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "150",
    height: "35",
    src: "https://bcr-img-new.s3.amazonaws.com/logo.png"
  })
], -1))
const _hoisted_5 = { class: "fs-11" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-end" }, "Licensed Financial Institution", -1))
const _hoisted_7 = { class: "d-flex text-end mt-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Account 账号 #:", -1))
const _hoisted_9 = { class: "ms-2" }
const _hoisted_10 = { style: {"text-decoration":"underline"} }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center mt-11 mb-11\" data-v-27ed0bc9><div class=\"fs-1\" data-v-27ed0bc9> KYC EVIDENCE VERIFICATION FORM / 客户信息核实证明表 </div><div class=\"fs-1\" data-v-27ed0bc9>Bacera Co Pty Ltd</div><div class=\"fs-3\" data-v-27ed0bc9> For Individuals, Individual Beneficial Owners and Sole Traders </div><div class=\"fs-3\" data-v-27ed0bc9>供个人，个人实益拥有者和个体经营者使用</div></div>", 1)
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, " I. Collection of Minimum KYC Information 客户基础信息采集 ", -1))
const _hoisted_13 = { style: {"width":"100%"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Surname"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "姓")
], -1))
const _hoisted_15 = { class: "kyc-input-col-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Given Name:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "名")
], -1))
const _hoisted_17 = { class: "kyc-input-col-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Prior Name"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "曾用名")
], -1))
const _hoisted_19 = { class: "kyc-input-col-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date of Birth"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "出生日期")
], -1))
const _hoisted_21 = { class: "kyc-input-col-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Residential Address"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "居住地址")
], -1))
const _hoisted_23 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Social Media Accounts"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "社交媒体帐户 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, " [ WhatsApp/WeChat ( 微信 ) /Instagram/Telegram ]")
], -1))
const _hoisted_25 = {
  colspan: "3",
  class: "kyc-input-col-8 fs-3"
}
const _hoisted_26 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_27 = { class: "me-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "AU Citizen or hold a passport from another country?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "是否为澳大利亚联邦公民或持有他国护照?")
], -1))
const _hoisted_29 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_30 = { style: {"font-size":"12px"} }
const _hoisted_31 = { class: "d-flex align-items-center mb-3" }
const _hoisted_32 = ["checked"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "AU Citizen 澳大利亚联邦公民", -1))
const _hoisted_34 = { class: "d-flex" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = ["checked"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Foreign Passport Holder 外国护照持有人", -1))
const _hoisted_38 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_39 = { style: {"font-size":"12px"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = {
  key: 0,
  class: "ms-2",
  style: {"text-transform":"uppercase"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Country of Residence"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "居住國家/地區")
], -1))
const _hoisted_43 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_44 = {
  key: 0,
  class: "ms-2",
  style: {"text-transform":"uppercase"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "E-mail Address"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "电子邮箱")
], -1))
const _hoisted_46 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Industry of Employment"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "工作行业")
], -1))
const _hoisted_48 = { class: "kyc-input-col-3" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Position"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "职位")
], -1))
const _hoisted_50 = { class: "kyc-input-col-3" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  colspan: "2",
  class: "kyc-label-col-2"
}
const _hoisted_53 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"12px"}
}
const _hoisted_54 = { class: "d-flex align-items-center mb-3" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-11 mb-11" }, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "For Sole Trader Only"),
  /*#__PURE__*/_createTextVNode("/仅供个体经营者 ")
], -1))
const _hoisted_57 = { style: {"width":"100%"} }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Full Business Name"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "公司全稱")
], -1))
const _hoisted_59 = { class: "kyc-input-col-3" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Business Number"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "商務號碼")
], -1))
const _hoisted_61 = { class: "kyc-input-col-3" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Full Business Address ( No PO Box )"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "辦公地址")
], -1))
const _hoisted_63 = { class: "kyc-input-col-3" }
const _hoisted_64 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_65 = {
  class: "d-flex",
  style: {"font-size":"12px"}
}
const _hoisted_66 = { style: {"width":"50%"} }
const _hoisted_67 = { class: "d-flex align-items-center" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("City/Suburb"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("城市")
], -1))
const _hoisted_69 = { class: "ms-5 fs-3" }
const _hoisted_70 = { class: "d-flex align-items-center" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Zip/Postal"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("邮编")
], -1))
const _hoisted_72 = { class: "ms-5 fs-3" }
const _hoisted_73 = { style: {"width":"50%"} }
const _hoisted_74 = { class: "d-flex align-items-center" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("State/Territory"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("州 / 省")
], -1))
const _hoisted_76 = { class: "ms-5 fs-3" }
const _hoisted_77 = { class: "d-flex align-items-center" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Country"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("国家")
], -1))
const _hoisted_79 = { class: "ms-5 fs-3" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Nature and purpose of the business relationship between BCR and the client"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "BCR与客户之间业务关系的性质和目的")
], -1))
const _hoisted_81 = { class: "kyc-input-col-3" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Reason for the client requiring our services (incl. supporting documents, e.g. overseas suppliers’ invoices)"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "客户需要我方提供服务的原因(包括支持文件，例如海外供应商的发票)")
], -1))
const _hoisted_83 = { class: "kyc-input-col-3" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Industry in which the client operates"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "客户经营所属行业")
], -1))
const _hoisted_85 = { class: "kyc-input-col-3" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, " The main 3 industries in which the client’s customers operate"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "客户的客人所属的3个主要行业")
], -1))
const _hoisted_87 = { class: "kyc-input-col-3" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, "1.", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, "2.", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, "3.", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "An explanation of a typical service provided by the client to its customers"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "客户向其客人提供的一项典型服务的详细描述")
], -1))
const _hoisted_92 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-11" }, "II. Verification/ 客户信息核实", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, " At a minimum, CLIENTS’ FULL NAME and either their DATE OF BIRTH or RESIDENTIAL ADDRESS must be verified. "),
  /*#__PURE__*/_createElementVNode("div", null, "最低限度,客户姓名和出生日期或住址必须核实.")
], -1))
const _hoisted_95 = { style: {"width":"100%"} }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Type of Document"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "⽂件类型")
], -1))
const _hoisted_97 = { class: "kyc-input-col-3" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { key: 2 }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Document ID number"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "⽂件号码")
], -1))
const _hoisted_102 = { class: "kyc-input-col-3" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date of birth"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "出生日期")
], -1))
const _hoisted_104 = { class: "kyc-input-col-3" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Place of residence"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "居住地址")
], -1))
const _hoisted_106 = { class: "kyc-input-col-3" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date of Issue"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签发日期")
], -1))
const _hoisted_108 = { class: "kyc-input-col-3" }
const _hoisted_109 = { key: 0 }
const _hoisted_110 = { key: 1 }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Expiry"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "过期日")
], -1))
const _hoisted_112 = { class: "kyc-input-col-3" }
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-11 mb-5" }, "Verification Method/ 核实方法", -1))
const _hoisted_116 = { style: {"width":"100%"} }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Verification Method"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "核实方法")
], -1))
const _hoisted_118 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"12px"}
}
const _hoisted_119 = { class: "d-flex align-items-center mb-3" }
const _hoisted_120 = ["checked"]
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Traditional Verification/传统核实", -1))
const _hoisted_122 = { class: "d-flex align-items-center" }
const _hoisted_123 = ["checked"]
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, "Electronic Verification/电子核实", -1))
const _hoisted_125 = { class: "d-flex align-items-center ms-2 me-2" }
const _hoisted_126 = ["checked"]
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Data Zoo", -1))
const _hoisted_128 = { class: "d-flex align-items-center ms-2 me-2" }
const _hoisted_129 = ["checked"]
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "MemberCheck", -1))
const _hoisted_131 = {
  class: "mt-7",
  style: {"width":"100%"}
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "text-center fw-bold" }, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "kyc-label-col-5",
    style: {"font-size":"14px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Traditional Verification/传统核实")
  ]),
  /*#__PURE__*/_createElementVNode("td", {
    class: "kyc-label-col-5",
    style: {"font-size":"14px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Electronic Verification/电子核实")
  ])
], -1))
const _hoisted_133 = {
  class: "kyc-input-col-5",
  style: {"font-size":"12px"}
}
const _hoisted_134 = { class: "d-flex align-items-center" }
const _hoisted_135 = ["checked"]
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Verification method 1/核实方法1", -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-6" }, [
  /*#__PURE__*/_createElementVNode("div", null, " Original or certified copy of a primary photographic identification document/ "),
  /*#__PURE__*/_createElementVNode("div", null, "首要的含照片身份证明文件的原始件或经认证的复印/")
], -1))
const _hoisted_138 = { class: "d-flex align-items-center mt-3" }
const _hoisted_139 = ["checked"]
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Verification method 2/核实方法2", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-6" }, [
  /*#__PURE__*/_createElementVNode("div", null, " Original or certified copy of a primary non-photographic identification document; AND/OR "),
  /*#__PURE__*/_createElementVNode("div", null, " 首要的不含照片的身份证明文件原始件或经认证的复印件; 以及/或 "),
  /*#__PURE__*/_createElementVNode("div", null, " Original or certified copy of a secondary identification document; "),
  /*#__PURE__*/_createElementVNode("div", null, "二级身份证明文件的原始件或经认证的复印;")
], -1))
const _hoisted_142 = {
  class: "kyc-input-col-5",
  style: {"font-size":"12px"}
}
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("Verify information collected about a client from: "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("收集的关于核实客户信息来源于:")
  ])
], -1))
const _hoisted_144 = { class: "d-flex align-items-center" }
const _hoisted_145 = ["checked"]
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-3" }, [
  /*#__PURE__*/_createTextVNode(" Reliable and independent documentation "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("可靠且独立的文件 ")
], -1))
const _hoisted_147 = { class: "d-flex align-items-center mt-3" }
const _hoisted_148 = ["checked"]
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" Reliable and independent electronic data from at least two (2) separate data source "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("来自至少两 (2) 个单独数据源的可靠且独立的电子数据 ")
  ])
], -1))
const _hoisted_150 = { class: "d-flex align-items-center mt-3" }
const _hoisted_151 = ["checked"]
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("A combination of both of the above "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("上面两者结合")
  ])
], -1))
const _hoisted_153 = {
  class: "mt-7",
  style: {"width":"100%"}
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Compliance Notes"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "合规部门备注")
], -1))
const _hoisted_155 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"16px","color":"#900000","white-space":"pre-line"}
}
const _hoisted_156 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-12\" data-v-27ed0bc9><div class=\"mb-5\" style=\"font-weight:bold;\" data-v-27ed0bc9><div data-v-27ed0bc9> Where a client cannot provide satisfactory evidence of identity: </div><div data-v-27ed0bc9>当客户无法提供令人满意的身份证明时：</div></div><div class=\"mb-5\" data-v-27ed0bc9><div data-v-27ed0bc9> Where a client does not possess and is unable to obtain the necessary information or evidence of identity, then in limited and exceptional cases, we may use alternative identity proofing process, which are commensurate with our risk-based systems and controls. </div></div><div class=\"mb-5\" data-v-27ed0bc9><div data-v-27ed0bc9> In these limited and exceptional cases, the matter will be referred to the AML/CTF compliance officer who may accept a self-attestation from the client, if they are not aware that the self-attestation is incorrect or misleading. The AML/CTF compliance officer will also designate the client as being high risk and will implement the appropriate level of ongoing customer due diligence procedures which is commensurate with a high risk client. </div></div><div class=\"mb-5\" data-v-27ed0bc9><div data-v-27ed0bc9> 如果客户不拥有且无法获得必要的身份信息或证明，那么在有限和例外的情况下，我们可能会使用替代性的身份证明流程，该流程与基于风险的系统和控制措施相符。 </div></div><div class=\"mb-5\" data-v-27ed0bc9><div data-v-27ed0bc9> 在这些有限和例外的情况下，此事将转给可能接受客户自我证明的AML / CTF合规官員, 如果他们不知道该自我证明是不正确或具有误导性。AML / CTF合规官还将指定客户为高风险客户，并将实施与高风险客户相对应的适当级别的持续客户尽职调查程序。 </div></div></div>", 1)
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-11 mb-9",
  style: {"position":"relative"}
}, [
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text-center",
    style: {"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%, -50%)","background-color":"white","padding":"0px 10px 0px 18px"}
  }, [
    /*#__PURE__*/_createElementVNode("strong", null, "For Office Use Only/本公司专用（请勿填写）")
  ])
], -1))
const _hoisted_158 = { class: "d-flex justify-content-around" }
const _hoisted_159 = { style: {"width":"48%"} }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Admin Staff Member"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "办公室员工")
], -1))
const _hoisted_161 = { class: "kyc-input-col-3" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Position"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "职位")
], -1))
const _hoisted_163 = { class: "kyc-input-col-3" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Signature"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签名")
], -1))
const _hoisted_165 = { class: "kyc-input-col-3" }
const _hoisted_166 = ["src"]
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date Signed"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签字日期")
], -1))
const _hoisted_168 = { class: "kyc-input-col-3" }
const _hoisted_169 = { style: {"width":"48%"} }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Compliance Staff Member"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "合规部门员工")
], -1))
const _hoisted_171 = { class: "kyc-input-col-3" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Position"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "职位")
], -1))
const _hoisted_173 = { class: "kyc-input-col-3" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Signature"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签名")
], -1))
const _hoisted_175 = { class: "kyc-input-col-3" }
const _hoisted_176 = ["src"]
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date Signed"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签字日期")
], -1))
const _hoisted_178 = { class: "kyc-input-col-3" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-11 mb-11" }, null, -1))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, "COPY OF SUPPORTING DOCUMENTATION"),
  /*#__PURE__*/_createElementVNode("div", null, "支持性⽂件复印件")
], -1))
const _hoisted_181 = { width: "100%" }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Type of Document"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "⽂件类型")
], -1))
const _hoisted_183 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"12px"}
}
const _hoisted_184 = { class: "d-flex align-items-center mb-3" }
const _hoisted_185 = ["checked"]
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Passport (Country of Origin)/护照（原籍国）", -1))
const _hoisted_187 = { class: "d-flex align-items-center mb-3" }
const _hoisted_188 = ["checked"]
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Photo ID / DL (Country of Origin)/含照片身份证件/驾照（原籍国） ", -1))
const _hoisted_190 = { class: "d-flex align-items-center" }
const _hoisted_191 = ["checked"]
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Financial Statement/Utility Bill/Government Document/ 财务证明/水电费账单/政府文件 ", -1))
const _hoisted_193 = /*#__PURE__*/_createStaticVNode("<hr class=\"mt-11 mb-11\" data-v-27ed0bc9><div class=\"my-8\" data-v-27ed0bc9><div class=\"text-xs font-semibold mb-6 tracking-widerr\" data-v-27ed0bc9><div data-v-27ed0bc9> You must verify the CLIENT’S FULL NAME and either their DATE OF BIRTH or RESIDENTIAL ADDRESS using: </div><div data-v-27ed0bc9>您必须利用以下资料确认客户姓名和出生日期或住址信息:</div></div><div class=\"p-4\" style=\"border:1px solid lightgray;\" data-v-27ed0bc9><div class=\"text-xs font-semibold mb-4 tracking-widerr\" data-v-27ed0bc9><div data-v-27ed0bc9> AN ORIGINAL OR CERTIFIED COPY OF A PRIMARY PHOTOGRAPHIC IDENTIFICATION DOCUMENT </div><div data-v-27ed0bc9>一份含照⽚的首要身份证明⽂件原始件或认证的复印件</div></div><div class=\"px-8\" data-v-27ed0bc9><ul class=\"list-disc list-outside text-3xs\" data-v-27ed0bc9><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9> A license or permit issued under a law of a State or Territory or equivalent authority of a foreign country for the purpose of driving a vehicle that contains a photograph of the person in whose name the document is issued; </div><div data-v-27ed0bc9> 州或领地或其他外国的政府或同等权威机构颁发的含申请人姓名及照⽚的用于驾驶车辆的许可证件; </div></li><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9>a passport issued by the Commonwealth;</div><div data-v-27ed0bc9>联邦颁发的护照;</div></li><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9> a passport or a similar document issued for the purpose of international travel, that: </div><div data-v-27ed0bc9>护照或其他和护照性质一样用于国际旅行的⽂件:</div><div class=\"px-8\" data-v-27ed0bc9><ol class=\"list-decimal list-outside text-3xs\" data-v-27ed0bc9><li data-v-27ed0bc9><div data-v-27ed0bc9> Contains a photograph and the signature of the person in whose the document is issued; </div><div data-v-27ed0bc9>签发的⽂件需包含申请人照⽚和签名;</div></li><li data-v-27ed0bc9><div data-v-27ed0bc9> is issued by a foreign government, the United Nations or an agency of the United Nations; and </div><div data-v-27ed0bc9>由外国政府, 联合国或联合国所属机构颁发, 以及</div></li><li data-v-27ed0bc9><div data-v-27ed0bc9> if it is written in a language that is not understood by the person carrying out the the verification – is accompanied by an English translation prepared by an accredit translator. </div><div data-v-27ed0bc9> 如果进行验证的人对⽂件所用语言并不了解或认知,需由授权翻译机构翻译成英⽂. </div></li></ol></div></li><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9> A card issued under the law of a State or Territory for the purpose of proving the person’s age which contains a photograph of the person in whose name the document is issued. </div><div data-v-27ed0bc9> 按照州或领地法律颁发的用于证明申请人年龄的包含申请人照⽚及姓名的证件. </div></li><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9> A national identity card issued for the purpose of identification, that: </div><div data-v-27ed0bc9>用于识别身份的国民身份证:</div><div class=\"px-8\" data-v-27ed0bc9><ol class=\"list-decimal list-outside text-3xs mx-2\" data-v-27ed0bc9><li data-v-27ed0bc9><div data-v-27ed0bc9> Contains a photograph and a signature of the person in whose name the document is issued; </div><div data-v-27ed0bc9>包含申请人照⽚和签名;</div></li><li data-v-27ed0bc9><div data-v-27ed0bc9> is issued by a foreign government, the United Nations or an agency of the United Nations if it is written in a language that is not understood by the person carrying out the verification – is accompanied by an English translation prepared by an accredit translator. </div><div data-v-27ed0bc9> 由外国政府, 联合国或联合国所属机构颁发, 如进行验证的人对⽂件所用语言并不了解或认知, 需由授权翻译机构翻译成英⽂. </div></li></ol></div></li></ul></div></div></div><div class=\"text-xs font-semibold text-center w-full tracking-widerr mb-7\" data-v-27ed0bc9> OR / 或 </div><div class=\"p-4\" style=\"border:1px solid lightgray;\" data-v-27ed0bc9><div class=\"text-xs font-semibold mb-4 tracking-widerr\" data-v-27ed0bc9><div data-v-27ed0bc9> AN ORIGINAL OR CERTIFIED COPY OF A PRIMARY PHOTOGRAPHIC IDENTIFICATION DOCUMENT </div><div data-v-27ed0bc9>一份含照⽚的首要身份证明⽂件原始件或认证的复印件</div></div><div class=\"px-8\" data-v-27ed0bc9><ul class=\"list-disc list-outside text-3xs\" data-v-27ed0bc9><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9> A birth certificate or birth extract issued by a State or Territory; </div><div data-v-27ed0bc9>由州或领地颁发的出生证明或出生信息摘要;</div></li><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9>a citizenship certificate issued by the Commonwealth;</div><div data-v-27ed0bc9>由联邦颁发的公民证明;</div></li><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9> a citizenship certificate issued by a foreign government that, if it is written in a language that is not understood by the person carrying out the verification, is accompanied by an English translation prepared by an accredited translator; </div><div data-v-27ed0bc9> 由外国政府颁发的公民证明, 如进行验证的人对⽂件所用语言并不了解或认知, 需由授权翻译机构翻译成英⽂. </div></li><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9> a birth certificate issued by a foreign government, the United Nations or an agency of the United Nations that, if it is written in a language that is not understood by the person carrying out the verification, is accompanied by an English translation prepared by an accredited translator; </div><div data-v-27ed0bc9> 由外国政府,联合国或联合国所属机构颁发的出生证明, 如进行验证的人对⽂件所用语言并不了解或认知, 需由授权翻译机构翻译成英⽂; </div></li><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9> a pension card issued by Centrelink that entitles the person in whose name the card is issued, to financial benefits. </div><div data-v-27ed0bc9> 由centrelink发出的, 基于财务效益, 授予申请人的包含申请人姓名的养⽼金卡. </div></li></ul></div><div class=\"text-xs font-semibold text-center w-full my-8 tracking-widerr\" data-v-27ed0bc9> AND / 以及 </div><div class=\"text-xs font-semibold mb-4 tracking-widerr\" data-v-27ed0bc9><div data-v-27ed0bc9> AN ORIGINAL OR CERTIFIED COPY OF A SECONDARY IDENTIFICATION DOCUMENT </div><div data-v-27ed0bc9>一份含照⽚的二级身份证明⽂件原始件或认证的复印件</div></div><div class=\"px-8\" data-v-27ed0bc9><ul class=\"list-disc list-outside text-3xs\" data-v-27ed0bc9><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9>A notice that / 一份声明:</div><div class=\"px-8\" data-v-27ed0bc9><ol class=\"list-decimal list-outside text-3xs\" data-v-27ed0bc9><li data-v-27ed0bc9><div data-v-27ed0bc9> was issued to an individual by the Commonwealth, a State or Territory within the preceding twelve months; </div><div data-v-27ed0bc9>由聯邦或州或領地在前12個月內簽發給個人的;</div></li><li data-v-27ed0bc9><div data-v-27ed0bc9> contains the name of the individual and his or her residential address; and </div><div data-v-27ed0bc9>包含個人姓名和他/她的住址信息; 以及</div></li><li data-v-27ed0bc9><div data-v-27ed0bc9> records the provision of financial benefits to the individual under a law of the Commonwealth, State or Territory (as the case may be); </div><div data-v-27ed0bc9> 根據聯邦或州或領地法律提供個人財務收益的記錄(視情況而定); </div></li></ol></div></li><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9>A notice that / 一份声明:</div><div class=\"px-8\" data-v-27ed0bc9><ol class=\"list-decimal list-outside text-3xs\" data-v-27ed0bc9><li data-v-27ed0bc9><div data-v-27ed0bc9> was issued to an individual by the Australian Taxation Office within the preceding 12 months; </div><div data-v-27ed0bc9>由澳大利亞稅務機構在前12個月內簽發給個人的;</div></li><li data-v-27ed0bc9><div data-v-27ed0bc9> contains the name of the individual and his or her residential address; and </div><div data-v-27ed0bc9>包含個人姓名和他/她的住址信息; 以及</div></li><li data-v-27ed0bc9><div data-v-27ed0bc9> records a debt payable to or by the individual by or to (respectively) the Commonwealth under Commonwealth law relating to taxation; </div><div data-v-27ed0bc9>根據聯邦稅務相關法律關於個人債務支付的記錄;</div></li></ol></div></li><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9>A notice that / 一份声明:</div><div class=\"px-8\" data-v-27ed0bc9><ol class=\"list-decimal list-outside text-3xs\" data-v-27ed0bc9><li data-v-27ed0bc9><div data-v-27ed0bc9> was issued to an individual by a local government body or utilities provider within the preceding three months; </div><div data-v-27ed0bc9>由當地政府或公共事業機構在前3個月內簽發給個人的;</div></li><li data-v-27ed0bc9><div data-v-27ed0bc9> contains the name of the individual and his or her residential address; and </div><div data-v-27ed0bc9>包含個人姓名和他/她的住址信息; 以及</div></li><li data-v-27ed0bc9><div data-v-27ed0bc9> records the provision of services by that local government body or utilities provider to that address or to that person. </div><div data-v-27ed0bc9> 由當地政府機構或公共事業機構對該住址或個人提供的服務記錄. </div></li></ol></div></li><li class=\"mb-2\" data-v-27ed0bc9><div data-v-27ed0bc9>A notice that / 一份声明:</div><div class=\"px-8\" data-v-27ed0bc9><ol class=\"list-decimal list-outside text-3xs\" data-v-27ed0bc9><li data-v-27ed0bc9><div data-v-27ed0bc9> was issued to a person by a school principal within the preceding three months; </div><div data-v-27ed0bc9>由學校校長在前3個月之內簽發給個人的；</div></li><li data-v-27ed0bc9><div data-v-27ed0bc9> contains the name of the person and his or her residential address; and </div><div data-v-27ed0bc9>包含個人姓名和他/她的住址信息; 以及</div></li><li data-v-27ed0bc9><div data-v-27ed0bc9> records the period of time that the person attended at the school. </div><div data-v-27ed0bc9>提供個人在校時間的記錄.</div></li></ol></div></li></ul></div></div><footer class=\"text-center mt-11\" data-v-27ed0bc9><p data-v-27ed0bc9>Level 18, Suite 3, 201 Elizabeth Street, NSW 2000 Australia</p><p data-v-27ed0bc9>Bacera Co Pty Ltd | ACN 130 877 137 | AFSL 328794</p></footer>", 5)

import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import financialTest from "@/core/data/verification/auFinancialQuestions";


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewAuKycForm',
  props: {
    kycInfos: {},
    regionCodes: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const predefinedOccupationValues = [
  "director",
  "manager",
  "entry_level",
  "other",
];
const getOccupationLabel = (occupation: string) => {
  if (predefinedOccupationValues.includes(occupation)) {
    return t(`fields.${occupation}`);
  }

  return occupation;
};
console.log("regionCodes", props.regionCodes);
console.log("kycInfos", props.kycInfos);
// watch(
//   () => props.kycInfos,
//   () => {
//     item.value = {
//       ...props.verificationDetails?.financial,
//     };
//   }
// );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, "   " + _toDisplayString(props.kycInfos.accountNumber) + "   ", 1)
          ])
        ])
      ])
    ]),
    _hoisted_11,
    _createElementVNode("div", null, [
      _hoisted_12,
      _createElementVNode("table", _hoisted_13, [
        _createElementVNode("tr", null, [
          _hoisted_14,
          _createElementVNode("td", _hoisted_15, _toDisplayString(props.kycInfos.lastName), 1),
          _hoisted_16,
          _createElementVNode("td", _hoisted_17, _toDisplayString(props.kycInfos.firstName), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_18,
          _createElementVNode("td", _hoisted_19, _toDisplayString(props.kycInfos.priorName), 1),
          _hoisted_20,
          _createElementVNode("td", _hoisted_21, _toDisplayString(props.kycInfos.birthday), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_22,
          _createElementVNode("td", _hoisted_23, _toDisplayString(props.kycInfos.address), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_24,
          _createElementVNode("td", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kycInfos.socialMediaTypes, (type, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (type.account != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("fields." + type.name)) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(type.account), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_28,
          _createElementVNode("td", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("input", {
                  class: "me-4",
                  type: "checkbox",
                  checked: props.kycInfos.citizen?.toLowerCase() == 'au'
                }, null, 8, _hoisted_32),
                _hoisted_33
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: 
                        !!props.kycInfos.citizen &&
                        props.kycInfos.citizen?.toLowerCase() != 'au'
                      
                    }, null, 8, _hoisted_36),
                    _hoisted_37
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("td", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createTextVNode(" Please provide details "),
              _hoisted_40,
              _createTextVNode("请提供细节: "),
              (props.kycInfos.citizen)
                ? (_openBlock(), _createElementBlock("strong", _hoisted_41, _toDisplayString(props.regionCodes[props.kycInfos.citizen?.toLowerCase()]
                    ?.name || "N/A") + " Citizen ", 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_42,
          _createElementVNode("td", _hoisted_43, [
            (props.kycInfos.residence)
              ? (_openBlock(), _createElementBlock("strong", _hoisted_44, _toDisplayString(props.regionCodes[props.kycInfos.residence?.toLowerCase()]
                  ?.name || "N/A"), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_45,
          _createElementVNode("td", _hoisted_46, _toDisplayString(props.kycInfos.email), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_47,
          _createElementVNode("td", _hoisted_48, _toDisplayString(props.kycInfos.industry.charAt(0).toUpperCase() +
              props.kycInfos.industry.slice(1)), 1),
          _hoisted_49,
          _createElementVNode("td", _hoisted_50, [
            (props.kycInfos.occupation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(getOccupationLabel(props.kycInfos.occupation)), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(financialTest)['en-us'], (item, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", _hoisted_52, [
              _createElementVNode("span", null, "( " + _toDisplayString(index) + " ) " + _toDisplayString(item.question), 1)
            ]),
            _createElementVNode("td", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", null, [
                  (
                    Array.isArray(props.kycInfos['financialInfo']['q' + index])
                  )
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.kycInfos['financialInfo'][
                      'q' + index
                    ], (option, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(_unref(financialTest)["en-us"][index].options[option]), 1))
                      }), 128))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(financialTest)["en-us"][index].options[
                      props.kycInfos["financialInfo"]["q" + index]
                    ]), 1)
                      ], 64))
                ])
              ])
            ])
          ]))
        }), 128))
      ]),
      _hoisted_55,
      _hoisted_56,
      _createElementVNode("table", _hoisted_57, [
        _createElementVNode("tr", null, [
          _hoisted_58,
          _createElementVNode("td", _hoisted_59, _toDisplayString(props.kycInfos.businessName), 1),
          _hoisted_60,
          _createElementVNode("td", _hoisted_61, _toDisplayString(props.kycInfos.businessNumber), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_62,
          _createElementVNode("td", _hoisted_63, _toDisplayString(props.kycInfos.businessAddress), 1),
          _createElementVNode("td", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _hoisted_68,
                  _createElementVNode("div", _hoisted_69, _toDisplayString(props.kycInfos.businessCity), 1)
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("div", _hoisted_72, _toDisplayString(props.kycInfos.businessZipCode), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _hoisted_75,
                  _createElementVNode("div", _hoisted_76, _toDisplayString(props.kycInfos.businessState), 1)
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _createElementVNode("div", _hoisted_79, _toDisplayString(props.kycInfos.businessCountry), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_80,
          _createElementVNode("td", _hoisted_81, _toDisplayString(props.kycInfos.businessCompanyPurposeBetweenUs), 1),
          _hoisted_82,
          _createElementVNode("td", _hoisted_83, _toDisplayString(props.kycInfos.businessServiceRequireReason), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_84,
          _createElementVNode("td", _hoisted_85, _toDisplayString(props.kycInfos.businessIndustry), 1),
          _hoisted_86,
          _createElementVNode("td", _hoisted_87, [
            _createElementVNode("div", null, [
              _hoisted_88,
              _createTextVNode(_toDisplayString(props.kycInfos.businessClientIndustry1), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_89,
              _createTextVNode(_toDisplayString(props.kycInfos.businessClientIndustry2), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_90,
              _createTextVNode(_toDisplayString(props.kycInfos.businessClientIndustry3), 1)
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_91,
          _createElementVNode("td", _hoisted_92, _toDisplayString(props.kycInfos.businessService), 1)
        ])
      ]),
      _hoisted_93,
      _hoisted_94,
      _createElementVNode("table", _hoisted_95, [
        _createElementVNode("tr", null, [
          _hoisted_96,
          _createElementVNode("td", _hoisted_97, [
            (props.kycInfos.idType == 3)
              ? (_openBlock(), _createElementBlock("span", _hoisted_98, "Passport"))
              : _createCommentVNode("", true),
            (props.kycInfos.idType == 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_99, "Driver's License"))
              : _createCommentVNode("", true),
            (props.kycInfos.idType == 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_100, "Government ID"))
              : _createCommentVNode("", true)
          ]),
          _hoisted_101,
          _createElementVNode("td", _hoisted_102, _toDisplayString(props.kycInfos.idNumber), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_103,
          _createElementVNode("td", _hoisted_104, _toDisplayString(props.kycInfos.birthday), 1),
          _hoisted_105,
          _createElementVNode("td", _hoisted_106, _toDisplayString(props.kycInfos.address), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_107,
          _createElementVNode("td", _hoisted_108, [
            (
                props.kycInfos.idIssuedOn == '0001-01-01' ||
                props.kycInfos.idIssuedOn == '' ||
                props.kycInfos.idIssuedOn == null
              )
              ? (_openBlock(), _createElementBlock("span", _hoisted_109, "N/A"))
              : (_openBlock(), _createElementBlock("span", _hoisted_110, _toDisplayString(props.kycInfos.idIssuedOn), 1))
          ]),
          _hoisted_111,
          _createElementVNode("td", _hoisted_112, [
            (
                props.kycInfos.idExpireOn == '0001-01-01' ||
                props.kycInfos.idExpireOn == '' ||
                props.kycInfos.idExpireOn == null
              )
              ? (_openBlock(), _createElementBlock("span", _hoisted_113, "N/A"))
              : (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(props.kycInfos.idExpireOn), 1))
          ])
        ])
      ]),
      _hoisted_115,
      _createElementVNode("table", _hoisted_116, [
        _createElementVNode("tr", null, [
          _hoisted_117,
          _createElementVNode("td", _hoisted_118, [
            _createElementVNode("div", _hoisted_119, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: 
                  props.kycInfos.electronicOrTraditional == 'traditional'
                
              }, null, 8, _hoisted_120),
              _hoisted_121
            ]),
            _createElementVNode("div", _hoisted_122, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: 
                  props.kycInfos.electronicOrTraditional == 'electronic'
                
              }, null, 8, _hoisted_123),
              _hoisted_124,
              _createTextVNode(" ( "),
              _createElementVNode("div", _hoisted_125, [
                _createElementVNode("input", {
                  class: "me-2",
                  type: "checkbox",
                  checked: props.kycInfos.electronicSourceOption == 'dataZoo'
                }, null, 8, _hoisted_126),
                _hoisted_127
              ]),
              _createElementVNode("div", _hoisted_128, [
                _createElementVNode("input", {
                  class: "me-2",
                  type: "checkbox",
                  checked: 
                    props.kycInfos.electronicSourceOption == 'memberCheck'
                  
                }, null, 8, _hoisted_129),
                _hoisted_130
              ]),
              _createTextVNode(" ) ")
            ])
          ])
        ])
      ]),
      _createElementVNode("table", _hoisted_131, [
        _hoisted_132,
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_133, [
            _createElementVNode("div", _hoisted_134, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: props.kycInfos.traditionalOption == 'traditional1'
              }, null, 8, _hoisted_135),
              _hoisted_136
            ]),
            _hoisted_137,
            _createElementVNode("div", _hoisted_138, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: props.kycInfos.traditionalOption == 'traditional2'
              }, null, 8, _hoisted_139),
              _hoisted_140
            ]),
            _hoisted_141
          ]),
          _createElementVNode("td", _hoisted_142, [
            _hoisted_143,
            _createElementVNode("div", _hoisted_144, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: props.kycInfos.electronicOption == '0'
              }, null, 8, _hoisted_145),
              _hoisted_146
            ]),
            _createElementVNode("div", _hoisted_147, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: props.kycInfos.electronicOption == '1'
              }, null, 8, _hoisted_148),
              _hoisted_149
            ]),
            _createElementVNode("div", _hoisted_150, [
              _createElementVNode("input", {
                class: "me-2",
                type: "checkbox",
                checked: props.kycInfos.electronicOption == '2'
              }, null, 8, _hoisted_151),
              _hoisted_152
            ])
          ])
        ])
      ]),
      _createElementVNode("table", _hoisted_153, [
        _createElementVNode("tr", null, [
          _hoisted_154,
          _createElementVNode("td", _hoisted_155, _toDisplayString(props.kycInfos.complianceNote), 1)
        ])
      ]),
      _hoisted_156
    ]),
    _hoisted_157,
    _createElementVNode("div", _hoisted_158, [
      _createElementVNode("table", _hoisted_159, [
        _createElementVNode("tr", null, [
          _hoisted_160,
          _createElementVNode("td", _hoisted_161, _toDisplayString(props.kycInfos.staffName), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_162,
          _createElementVNode("td", _hoisted_163, _toDisplayString(props.kycInfos.staffPosition), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_164,
          _createElementVNode("td", _hoisted_165, [
            _createElementVNode("img", {
              src: props.kycInfos.staffSignature,
              height: "80",
              alt: ""
            }, null, 8, _hoisted_166)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_167,
          _createElementVNode("td", _hoisted_168, _toDisplayString(props.kycInfos.staffSignedOn), 1)
        ])
      ]),
      _createElementVNode("table", _hoisted_169, [
        _createElementVNode("tr", null, [
          _hoisted_170,
          _createElementVNode("td", _hoisted_171, _toDisplayString(props.kycInfos.complianceName), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_172,
          _createElementVNode("td", _hoisted_173, _toDisplayString(props.kycInfos.compliancePosition), 1)
        ]),
        _createElementVNode("tr", null, [
          _hoisted_174,
          _createElementVNode("td", _hoisted_175, [
            _createElementVNode("img", {
              src: props.kycInfos.complianceSignature,
              height: "80",
              alt: ""
            }, null, 8, _hoisted_176)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_177,
          _createElementVNode("td", _hoisted_178, _toDisplayString(props.kycInfos.complianceSignedOn), 1)
        ])
      ])
    ]),
    _hoisted_179,
    _hoisted_180,
    _createElementVNode("table", _hoisted_181, [
      _createElementVNode("tr", null, [
        _hoisted_182,
        _createElementVNode("td", _hoisted_183, [
          _createElementVNode("div", _hoisted_184, [
            _createElementVNode("input", {
              class: "me-2",
              type: "checkbox",
              checked: props.kycInfos.idType == '3'
            }, null, 8, _hoisted_185),
            _hoisted_186
          ]),
          _createElementVNode("div", _hoisted_187, [
            _createElementVNode("input", {
              class: "me-2",
              type: "checkbox",
              checked: props.kycInfos.idType == '2'
            }, null, 8, _hoisted_188),
            _hoisted_189
          ]),
          _createElementVNode("div", _hoisted_190, [
            _createElementVNode("input", {
              class: "me-2",
              type: "checkbox",
              checked: props.kycInfos.idType == '1'
            }, null, 8, _hoisted_191),
            _hoisted_192
          ])
        ])
      ])
    ]),
    _hoisted_193
  ]))
}
}

})